export const normalizeImageId = (id: string | null | undefined): string | null | undefined => {
    if (id) {
        return id.replace(/(?:-orig|-thumb)\.[^.]+$/gim, "");
    }

    return id;
};
